import { publicClient, privateClient } from '../apiClient';
import { DEMO_USER } from '../../mocks/auth/authMocks';
import type { LoginResponse, RegisterResponse, ForgotPasswordResponse, ResetPasswordResponse } from "../../types/auth/Auth";
import type { User } from "../../types/user/User";

class AuthService {
    private useMock = import.meta.env.VITE_USE_MOCK === 'true';

    async login(email: string, password: string): Promise<LoginResponse> {
        if (this.useMock) {
            localStorage.setItem('token', 'mock-token');
            return DEMO_USER;
        }
        const response = await publicClient.post('/auth/login', { email, password });
        localStorage.setItem('token', response.data.token);
        return response.data.user;
    }

    async register(firstName: string, lastName: string, email: string, password: string, website: string = ''): Promise<RegisterResponse> {
        if (this.useMock) {
            localStorage.setItem('token', 'mock-token');
            return DEMO_USER;
        }
        const response = await publicClient.post('/auth/register', {
            first_name: firstName,
            last_name: lastName,
            email,
            password,
            website, // honeypot: always empty for real users
        });
        localStorage.setItem('token', response.data.token);
        return response.data.user;
    }

    async forgotPassword(email: string): Promise<ForgotPasswordResponse> {
        if (this.useMock) return { success: true };
        const response = await publicClient.post('/auth/forgot-password', { email });
        return response.data;
    }

    async resetPassword(token: string, password: string): Promise<ResetPasswordResponse> {
        if (this.useMock) return { success: true };
        const response = await publicClient.post('/auth/reset-password', { token, password });
        return response.data;
    }

    async fetchCurrentUser(): Promise<User> {
        if (this.useMock) return DEMO_USER;
        const response = await privateClient.get('/auth/me');
        return response.data;
    }

    logout() {
        localStorage.removeItem('token');
    }
}

export default new AuthService();